<template>
  <div>
    <p class="xPadding titleModal">
      {{ $t(`treatmentProgram.steam.step3.title`) }}
    </p>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VSelect
          v-model="data.injection"
          :label="$t('treatmentProgram.steam.step3.title')"
          :items="indectionTypes"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <Schedule
        v-if="data.injection === 'schedule'"
        :schedule="data.schedule"
        @sendData="updateData"
      />
    </v-row>
    <v-row class="xPadding">
      <ProbeDriven
        v-if="data.injection === 'probeDriven'"
        :probeDriven="data.probeDriven"
        @sendData="updateData"
      />
    </v-row>
    <v-row
      v-if="data.injection === 'manual'"
      class="xPadding"
    >
      <v-col class="py-0">
        <VTextField
          v-model="data.manual"
          :label="$t('treatmentProgram.steam.step3.manual')"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="data.injection === 'time'"
      class="xPadding"
    >
      <v-col class="py-0">
        <VTextField
          v-model="data.time"
          :label="$t('treatmentProgram.steam.step3.timeText')"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="data.injection === 'other'"
      class="xPadding"
    >
      <v-col>
        <VTextField
          v-model="data.other"
          :label="$t('treatmentProgram.steam.step3.other')"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import Schedule from '@/components/forms/treatmentProgram/forms/sub-forms/steam/Schedule';
import ProbeDriven from '@/components/forms/treatmentProgram/forms/sub-forms/steam/ProbeDriven';
import { INJECTION_TYPES } from '@/constants/steamTreatmentPrograms';

export default {
    components: {
        Schedule,
        ProbeDriven,
    },
    props: {
        injectionControl: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        indectionTypes() {
            return INJECTION_TYPES.map(key => ({
                name: this.$t(`treatmentProgram.steam.step3.${key}`),
                key,
            }));
        },

    },
    watch: {
        injectionControl: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.injectionControl) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData(updatedData) {
            this.data = { ...this.data, ...updatedData };
            this.$emit('sendData', { injectionControl: this.data });
        },
        displayedUnits(type) {
            return this.treatmentProgramUnits && this.treatmentProgramUnits[type]
                ? this.treatmentProgramUnits[type] : [];
        },
    },
};
</script>
  <style lang="scss" scoped>
  .xPadding{
    padding: 0 6rem;
  }
  @media screen and (max-width: 600px) {
     .xPadding{
        padding: 0;
      }
  }
  </style>
